(function () {
  'use strict';

  function money(cents, format) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format(value);
    } catch (e) {
      return '$' + value.toFixed(2);
    }
  }

  function buildPairUrl(url, variantId, appendPair) {
    if (!url) return '#';
    var hash = '';
    var hashIndex = url.indexOf('#');
    if (hashIndex > -1) {
      hash = url.slice(hashIndex);
      url = url.slice(0, hashIndex);
    }

    var hasQuery = url.indexOf('?') > -1;
    var params = [];
    if (appendPair && url.indexOf('panel=') === -1) params.push('panel=pair');
    if (variantId) params.push('variant=' + encodeURIComponent(variantId));
    if (params.length) url += (hasQuery ? '&' : '?') + params.join('&');
    return url + hash;
  }

  function initLoadMore(section) {
    var items = Array.from(section.querySelectorAll('[data-hpd-pair-item]'));
    var button = section.querySelector('[data-hpd-load-more]');
    var wrap = section.querySelector('[data-hpd-load-more-wrap]');
    var count = section.querySelector('[data-hpd-visible-count]');

    if (!items.length || !button) return;

    var batch = Math.max(1, parseInt(section.dataset.loadMoreCount, 10) || 9);

    function visibleItems() {
      return items.filter(function (item) { return !item.hidden; });
    }

    function updateState() {
      var visible = visibleItems().length;
      if (count) count.textContent = String(visible);
      if (visible >= items.length && wrap) wrap.hidden = true;
    }

    button.addEventListener('click', function () {
      var hiddenItems = items.filter(function (item) { return item.hidden; });
      var nextItems = hiddenItems.slice(0, batch);
      if (!nextItems.length) {
        updateState();
        return;
      }

      nextItems.forEach(function (item) { item.hidden = false; });
      updateState();

      var firstNewAction = nextItems[0].querySelector('button:not([disabled]), a[href]');
      if (firstNewAction) {
        window.requestAnimationFrame(function () { firstNewAction.focus({ preventScroll: true }); });
      }
    });

    updateState();
  }

  function initSection(section) {
    if (!section || section.dataset.hpdPairReady === 'true') return;
    section.dataset.hpdPairReady = 'true';

    initLoadMore(section);

    var drawer = section.querySelector('[data-hpd-pair-drawer]');
    if (!drawer) return;

    var panel = drawer.querySelector('[data-hpd-drawer-panel]');
    var content = drawer.querySelector('[data-hpd-drawer-content]');
    var closeButtons = drawer.querySelectorAll('[data-hpd-drawer-close]');
    var lastTrigger = null;

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hpd-pair-drawer-open');
      if (lastTrigger) lastTrigger.focus();
    }

    function setSubmitState(productRoot) {
      var select = productRoot.querySelector('[data-hpd-variant-select]');
      var submit = productRoot.querySelector('[data-hpd-drawer-submit]');
      var price = productRoot.querySelector('[data-hpd-drawer-price] strong');
      var status = productRoot.querySelector('[data-hpd-drawer-status]');
      if (!select || !submit) return;

      var option = select.options[select.selectedIndex];
      var valid = !!(option && option.value && option.dataset.available !== 'false');
      submit.disabled = !valid;
      submit.textContent = valid ? section.dataset.addLabel : section.dataset.selectLabel;

      if (valid && price) price.textContent = money(option.dataset.price);
      if (status) {
        status.textContent = '';
        status.classList.remove('is-error', 'is-success');
      }
    }

    function updatePanelsNote(productRoot) {
      var qtyInput = productRoot.querySelector('[data-hpd-qty-input]');
      var note = productRoot.querySelector('[data-hpd-panels-note]');
      if (!qtyInput || !note) return;
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var units = parseInt(note.dataset.unitsPerPair, 10) || 2;
      var pairWord = qty === 1 ? section.dataset.pairSingular : section.dataset.pairPlural;
      note.textContent = qty + ' ' + pairWord + ' = ' + (qty * units) + ' ' + section.dataset.panelPlural;
    }

    function wireDrawerContent(productRoot) {
      var select = productRoot.querySelector('[data-hpd-variant-select]');
      var minus = productRoot.querySelector('[data-hpd-qty-minus]');
      var plus = productRoot.querySelector('[data-hpd-qty-plus]');
      var qtyInput = productRoot.querySelector('[data-hpd-qty-input]');
      var submit = productRoot.querySelector('[data-hpd-drawer-submit]');
      var status = productRoot.querySelector('[data-hpd-drawer-status]');

      if (select) select.addEventListener('change', function () { setSubmitState(productRoot); });

      if (minus && qtyInput) {
        minus.addEventListener('click', function () {
          qtyInput.value = Math.max(Number(qtyInput.min || 1), (parseInt(qtyInput.value, 10) || 1) - 1);
          updatePanelsNote(productRoot);
        });
      }

      if (plus && qtyInput) {
        plus.addEventListener('click', function () {
          var max = parseInt(qtyInput.max, 10) || 99;
          qtyInput.value = Math.min(max, (parseInt(qtyInput.value, 10) || 1) + 1);
          updatePanelsNote(productRoot);
        });
      }

      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          var min = parseInt(qtyInput.min, 10) || 1;
          var max = parseInt(qtyInput.max, 10) || 99;
          qtyInput.value = Math.min(max, Math.max(min, parseInt(qtyInput.value, 10) || min));
          updatePanelsNote(productRoot);
        });
      }

      if (submit) {
        submit.addEventListener('click', function () {
          var option = select && select.options[select.selectedIndex];
          if (!option || !option.value || option.dataset.available === 'false') return;

          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          var action = submit.dataset.submitAction || 'ajax_add';
          var productUrl = submit.dataset.productUrl || '';
          var appendPair = submit.dataset.appendPair === 'true';

          if (action === 'redirect') {
            window.location.href = buildPairUrl(productUrl, option.value, appendPair);
            return;
          }

          submit.disabled = true;
          submit.textContent = section.dataset.addingLabel;
          if (status) {
            status.textContent = '';
            status.classList.remove('is-error', 'is-success');
          }

          var properties = {};
          if (submit.dataset.soldAsKey) properties[submit.dataset.soldAsKey] = submit.dataset.soldAsValue || 'Pair (2 Panels)';
          if (submit.dataset.unitsKey) properties[submit.dataset.unitsKey] = submit.dataset.unitsValue || '2';

          fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(option.value),
                quantity: qty,
                properties: properties
              }]
            })
          })
            .then(function (response) {
              if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || data.message || 'Unable to add this pair.'); });
              return response.json();
            })
            .then(function () {
              if (status) {
                status.textContent = section.dataset.addedMessage;
                status.classList.add('is-success');
              }
              document.dispatchEvent(new CustomEvent('hpd:pair-added', { detail: { variantId: Number(option.value), quantity: qty } }));
              document.dispatchEvent(new CustomEvent('cart:refresh'));

              if (section.dataset.afterAdd === 'cart') {
                window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
                return;
              }

              submit.disabled = false;
              submit.textContent = section.dataset.addLabel;
            })
            .catch(function (error) {
              if (status) {
                status.textContent = error.message || section.dataset.errorMessage;
                status.classList.add('is-error');
              }
              submit.disabled = false;
              submit.textContent = section.dataset.addLabel;
            });
        });
      }

      setSubmitState(productRoot);
      updatePanelsNote(productRoot);
    }

    function openDrawer(trigger) {
      var templateId = trigger.dataset.templateId;
      var template = templateId && document.getElementById(templateId);
      if (!template) return;

      lastTrigger = trigger;
      content.innerHTML = '';
      content.appendChild(template.content.cloneNode(true));
      var productRoot = content.querySelector('[data-hpd-drawer-product]');
      if (productRoot) wireDrawerContent(productRoot);

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hpd-pair-drawer-open');

      window.requestAnimationFrame(function () {
        var firstField = content.querySelector('select, button, a, input');
        if (firstField) firstField.focus();
      });
    }

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-hpd-pair-open]');
      if (trigger) {
        event.preventDefault();
        openDrawer(trigger);
      }
    });

    closeButtons.forEach(function (button) { button.addEventListener('click', closeDrawer); });

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
      if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;

      var focusable = panel.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-hpd-pair-products]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
